module.exports = __webpack_public_path__ + "img/Logo.e1667479.png";